<template>
  <td :colspan="colspan">
    <template v-if="expandedData[item.id]">
      <v-row>
        <v-col cols="6">
          <p class="text-subtitle-1 text-center">Formular</p>
          <v-timeline dense>
            <v-timeline-item v-if="personalData[item.id]" :color="expandedData[item.id].draft ? 'error' : 'primary'">
              <v-card class="elevation-2">
                <v-card-title class="text-overline">
                  Date personale
                </v-card-title>
                <v-card-text>
                  <v-list dense two-line>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          Nume
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          {{ personalData[item.id].nume }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          Prenume
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          {{ personalData[item.id].prenume }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          CNP
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          {{ personalData[item.id].cnp }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          Judet
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          {{ personalData[item.id].judet }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          Carte de Identitate
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <a v-for="url in personalData[item.id].ciUrl" :href="url" download target="_blank" :key="url" class="text-decoration-none">
                            <v-icon>mdi-download</v-icon>
                          </a>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          Certificat
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <a v-for="url in personalData[item.id].certUrl" :href="url" download target="_blank" :key="url" class="text-decoration-none">
                            <v-icon>mdi-download</v-icon>
                          </a>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-timeline-item>

            <v-timeline-item
              v-for="key in formKeys"
              :key="key.key + item.id"
              :color="expandedData[item.id].draft ? 'error' : 'primary'">
              <v-card class="elevation-2">
                <v-card-title class="text-overline">
                  {{ key.title }}
                </v-card-title>
                <v-card-text>

                  <template v-if="key.key === 'draft'">
                    <v-icon :color="expandedData[item.id][key.key] ? 'error' : 'primary'">
                      {{ expandedData[item.id][key.key] ? "mdi-close" : "mdi-check" }}
                    </v-icon>
                    Aplicantul <strong v-if="expandedData[item.id][key.key]">NU</strong> a finalizat formularul

                    <br>

                    <v-btn v-if="['admin', 'el presidente'].includes(user.role) && !expandedData[item.id][key.key]" @click="openForm">Deblocheaza formularul</v-btn>
                  </template>
                  <template v-else-if="key.key === 'lastSave'">
                    {{ expandedData[item.id][key.key] ? new Date(expandedData[item.id][key.key]).toLocaleString("ro-RO") : "informatie indisponibila" }}
                  </template>
                  <template v-else-if="key.key === 'step1' && expandedData[item.id].step1">
                    <template v-for="property in ['cerere', 'declaratie', 'cazierjudiciar', 'cazierfiscal', 'cv']">
                      <v-card width="200" :key="property" style="display: inline-block" class="ma-4">
                        <v-img
                          class="white--text align-end"
                          height="100px"
                          :src="'img/files_closed.jpg'"
                        >
                        </v-img>
                        <v-card-subtitle>
                          {{ expandedData[item.id][key.key][property].name }}
                        </v-card-subtitle>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn icon @click="downloadFile(expandedData[item.id][key.key][property])">
                            <v-icon color="primary">
                              mdi-download
                            </v-icon>
                          </v-btn>
                          <v-spacer></v-spacer>
                          <span>
                            {{ (expandedData[item.id][key.key][property].size / 1000).toFixed(2) }} Kb
                          </span>
                          <v-spacer></v-spacer>
                          <v-icon small :color="expandedData[item.id][key.key][property].saved ? 'primary' : 'grey'">
                            {{ expandedData[item.id][key.key][property].saved ? 'mdi-check' : 'mdi-close' }}
                          </v-icon>
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </template>
                  </template>
                  <template v-else-if="key.key === 'step2' && expandedData[item.id].step2">
                    <template v-for="property in ['file']">
                      <v-card width="200" :key="property" style="display: inline-block" class="ma-4">
                        <v-img
                          class="white--text align-end"
                          height="100px"
                          :src="'img/files_closed.jpg'"
                        >
                        </v-img>
                        <v-card-subtitle>
                          {{ expandedData[item.id][key.key][property].name }}
                        </v-card-subtitle>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn icon @click="downloadFile(expandedData[item.id][key.key][property])">
                            <v-icon color="primary">
                              mdi-download
                            </v-icon>
                          </v-btn>
                          <v-spacer></v-spacer>
                          <span>
                            {{ (expandedData[item.id][key.key][property].size / 1000).toFixed(2) }} Kb
                          </span>
                          <v-spacer></v-spacer>
                          <v-icon small :color="expandedData[item.id][key.key][property].saved ? 'primary' : 'grey'">
                            {{ expandedData[item.id][key.key][property].saved ? 'mdi-check' : 'mdi-close' }}
                          </v-icon>
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </template>

                    <template v-for="property in text.step2">
                      <p :key="property.key" class="text-caption break-all">
                        <span class="font-weight-bold">{{ property.label }}: </span>
                        {{ expandedData[item.id][key.key][property.key] }}
                      </p>
                    </template>
                  </template>
                  <template v-else-if="key.key === 'step3' && expandedData[item.id].step3">
                    <template v-for="property in text.step3">
                      <p :key="property.key" class="text-caption break-all">
                        <v-icon v-if="expandedData[item.id][key.key].selected.includes(property.key)" color="success" small>
                          mdi-check-circle
                        </v-icon>
                        <v-icon v-else color="grey" small>
                          mdi-checkbox-blank-circle-outline
                        </v-icon>
                        <span class="font-weight-bold pl-2">{{ property.label }}: </span>
                      </p>
                    </template>
                  </template>
                  <template v-else-if="key.key === 'step4' && expandedData[item.id].step4">
                    <template v-for="property in ['xls', 'pdf']">
                      <v-card width="200" :key="property" style="display: inline-block" class="ma-4">
                        <v-img
                          class="white--text align-end"
                          height="100px"
                          :src="'img/files_closed.jpg'"
                        >
                        </v-img>
                        <v-card-subtitle>
                          {{ expandedData[item.id][key.key][property].name }}
                        </v-card-subtitle>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn icon @click="downloadFile(expandedData[item.id][key.key][property])">
                            <v-icon color="primary">
                              mdi-download
                            </v-icon>
                          </v-btn>
                          <v-spacer></v-spacer>
                          <span>
                            {{ (expandedData[item.id][key.key][property].size / 1000).toFixed(2) }} Kb
                          </span>
                          <v-spacer></v-spacer>
                          <v-icon small :color="expandedData[item.id][key.key][property].saved ? 'primary' : 'grey'">
                            {{ expandedData[item.id][key.key][property].saved ? 'mdi-check' : 'mdi-close' }}
                          </v-icon>
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </template>

                    <template v-for="property in text.step4">
                      <p :key="property.key" class="text-caption break-all">
                        <span class="font-weight-bold">{{ property.label }}: </span>
                        {{ expandedData[item.id][key.key][property.key] }} RON
                      </p>
                    </template>
                  </template>
                  <template v-else-if="key.key === 'step5' && expandedData[item.id].step5">
                    <template v-for="property in ['file']">
                      <v-card width="200" :key="property" style="display: inline-block" class="ma-4">
                        <v-img
                          class="white--text align-end"
                          height="100px"
                          :src="'img/files_closed.jpg'"
                        >
                        </v-img>
                        <v-card-subtitle>
                          {{ expandedData[item.id][key.key][property].name }}
                        </v-card-subtitle>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn icon @click="downloadFile(expandedData[item.id][key.key][property])">
                            <v-icon color="primary">
                              mdi-download
                            </v-icon>
                          </v-btn>
                          <v-spacer></v-spacer>
                          <span>
                            {{ (expandedData[item.id][key.key][property].size / 1000).toFixed(2) }} Kb
                          </span>
                          <v-spacer></v-spacer>
                          <v-icon small :color="expandedData[item.id][key.key][property].saved ? 'primary' : 'grey'">
                            {{ expandedData[item.id][key.key][property].saved ? 'mdi-check' : 'mdi-close' }}
                          </v-icon>
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </template>

                    <template v-for="property in text.step5">
                      <p :key="property.key" class="text-caption break-all">
                        <span class="font-weight-bold">{{ property.label }}: </span>
                        {{ expandedData[item.id][key.key][property.key] }}
                      </p>
                    </template>
                  </template>
                  <template v-else-if="key.key === 'step6' && expandedData[item.id].step6">
                    <template v-for="property in ['file', 'anotherfile']">
                      <v-card width="200" :key="property" style="display: inline-block" class="ma-4">
                        <v-img
                          class="white--text align-end"
                          height="100px"
                          :src="'img/files_closed.jpg'"
                        >
                        </v-img>
                        <v-card-subtitle>
                          {{ expandedData[item.id][key.key][property].name }}
                        </v-card-subtitle>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn icon @click="downloadFile(expandedData[item.id][key.key][property])">
                            <v-icon color="primary">
                              mdi-download
                            </v-icon>
                          </v-btn>
                          <v-spacer></v-spacer>
                          <span>
                            {{ (expandedData[item.id][key.key][property].size / 1000).toFixed(2) }} Kb
                          </span>
                          <v-spacer></v-spacer>
                          <v-icon small :color="expandedData[item.id][key.key][property].saved ? 'primary' : 'grey'">
                            {{ expandedData[item.id][key.key][property].saved ? 'mdi-check' : 'mdi-close' }}
                          </v-icon>
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </template>
                  </template>

                  <v-divider v-if="!['draft', 'lastSave'].includes(key.key)"></v-divider>
                  <v-subheader v-if="!['draft', 'lastSave'].includes(key.key)">Comentarii</v-subheader>

                  <template v-if="item.evaluare">
                    <template v-for="(ev, index) in item.evaluare">
                      <div class="ml-4 text-caption" :key="index" v-if="ev.comments && ev.comments.form && ev.comments.form[key.key] && canSee(ev.comisie)">
                        <strong>{{ ev.evaluator }} ({{ ev.comisie }}):</strong>
                        {{ ev.comments.form[key.key] }}
                      </div>
                    </template>
                  </template>
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-col>
        <v-col cols="6">
          <p class="text-subtitle-1 text-center">Evaluari</p>
          <v-list v-if="item.evaluare" dense>
            <template v-for="(ev, index) in item.evaluare">
              <template v-if="canSee(ev.comisie)">
                <v-subheader :key="index" class="font-weight-bold">
                  {{ ev.evaluator }} - Comisia {{ ev.comisie }} -
                  <v-icon small :color="ev.admis ? 'primary' : 'error'" :title="ev.admis ? 'Admis' : 'Respins'">
                    {{ ev.admis ? 'mdi-check' : 'mdi-close' }}
                  </v-icon>
                  -
                  {{ new Date(ev.data).toLocaleString("ro-RO") }}
                  <a v-if="ev.grila" :href="ev.grila" download target="_blank" class="ml-5 text-decoration-none">
                    grila
                    <v-icon small right color="primary">mdi-download</v-icon>
                  </a>
                </v-subheader>
                <template v-for="(points, section) in ev.points">
                  <v-subheader :key="index + section + 'subheader'" class="text-capitalize">
                    {{ section }} -
                    {{ ev.score[section] }} puncte
                  </v-subheader>
                  <template v-for="(score, sIndex) in points">
                    <v-list-item :key="index + section + sIndex" v-if="sIndex > 0">
                      <v-list-item-avatar color="primary" size="24" class="white--text">
                        {{ sIndex }}
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title>
                          {{ score }} puncte
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <div class="ml-14 text-caption" :key="index + section + sIndex + 'comments'" v-if="sIndex > 0 && ev.comments && ev.comments.points && ev.comments.points[section] && ev.comments.points[section][`step${sIndex}`]">
                      {{ ev.comments.points[section][`step${sIndex}`] }}
                    </div>
                  </template>
                </template>
              </template>
              <v-divider :key="index + 'divider'"></v-divider>
            </template>
          </v-list>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      Nu exista informatii asociate acestui utilizator.
    </template>

    <v-dialog persistent scrollable v-model="unlockFormDialog" width="500">
      <v-card class="pa-md-4 mx-auto" max-height="75vh">
        <v-card-title>
          <h1 class="text-h6 text-center mb-3">
            Deblocare formular
          </h1>
        </v-card-title>
        <v-card-text>
          Sunteti sigur(a) ca doriti sa deblocati formularul acestui utilizator?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeUnlockForm">Anulare</v-btn>
          <v-btn color="success" @click="confirmUnlockForm">Confirmare</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </td>
</template>

<script>
export default {
  name: "step-board",

  props: {
    colspan: {
      type: Number,
      required: true
    },
    expandedData: {
      type: Object,
      required: true
    },
    personalData: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    formKeys: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    text: Object.freeze({
      step2: [
        { key: 'denumire', label: 'a) Denumirea planului de afaceri' },
        { key: 'sediu', label: 'b) Sediul social' },
        { key: 'activitate', label: 'c) Activitate principala (CAEN)' },
        { key: 'derulare', label: 'd) Perioada de derulare a activitatilor pentru care se primeste subventia (obligatiu 18 luni)' },
        { key: 'sustenabilitate', label: 'e) Perioada de sustenabilitate (minimum 6 luni)' }
      ],
      step3: [
        { key: 'dezvoltare', label: 'a) Promovarea dezvoltarii durabile' },
        { key: 'egalitate', label: 'b) Egalitatea de sanse' },
        { key: 'co2', label: 'c) Reducerea emisiei de dioxid de carbon' },
        { key: 'tic', label: 'd) Utilizarea TIC' },
        { key: 'inovare', label: 'e) Inovare sociala' },
        { key: 'cercetare', label: 'f) Promovarea cercetarii' }
      ],
      step4: [
        { key: 'subventie', label: 'Valoarea subventiei solicitate' },
        { key: 'contributie', label: 'Contributia proprie' }
      ],
      step5: [
        { key: 'text', label: 'Mentioneaza numarul de angajati, conform planului de afaceri' }
      ]
    }),
    unlockFormDialog: false
  }),

  computed: {
    user() {
      return this.$store.getters.user;
    }
  },

  methods: {
    canSee(comisie) {
      return this.user.role === "admin" || this.user.comisie === comisie;
    },
    downloadFile(file) {
      const link = document.createElement("a");
      link.href = file.url;
      link.download = file.name;
      link.target = "_blank";
      link.click();
      link.remove();
    },

    openForm() {
      this.unlockFormDialog = true;
    },
    closeUnlockForm() {
      this.unlockFormDialog = false;
    },
    async confirmUnlockForm() {
      this.$store.dispatch("openForm", this.item.id);
      this.closeUnlockForm();
      this.$emit("reload");
    }
  }
};
</script>
